import {
  type FileSnapshot,
  type InventoryResource,
  SecurityScanConclusionEnum,
  SecurityScanResultEvidenceTypeEnum,
  type Snapshot,
} from '@repo/api-gw-sdk';

export const hasSecurityIssue = (
  entity: InventoryResource | Snapshot | FileSnapshot
) => {
  return (
    (entity.securityScan?.conclusion &&
      entity.securityScan.conclusion !== SecurityScanConclusionEnum.Clean) ||
    ('isInfected' in entity && !!entity.isInfected)
  );
};

const EvidenceTypeDisplayNameMapper: Record<
  SecurityScanResultEvidenceTypeEnum,
  { label: string; entity: string; description: string }
> = {
  [SecurityScanResultEvidenceTypeEnum.SuspiciousExtensionDetected]: {
    label: 'Ransomware File Signature',
    entity: 'file',
    description: 'found with suspicious signatures',
  },
  [SecurityScanResultEvidenceTypeEnum.SuspiciousActivityDetected]: {
    label: 'Moved files',
    entity: 'file',
    description: 'moved and encrypted',
  },
  [SecurityScanResultEvidenceTypeEnum.ModifiedFilesBecameEncrypted]: {
    label: 'File entropy',
    entity: 'file',
    description: 'found with suspicious entropy',
  },
  [SecurityScanResultEvidenceTypeEnum.MalwareDetected]: {
    label: 'Malware Detected',
    entity: 'file',
    description: 'malware signature detected',
  },
  [SecurityScanResultEvidenceTypeEnum.TableDeletion]: {
    label: 'Table Deletion',
    entity: 'table',
    description: 'database table was deleted',
  },
  [SecurityScanResultEvidenceTypeEnum.SignificantRowDecrease]: {
    label: 'Significant Row Decrease',
    entity: 'table',
    description: 'significant decrease in row count detected',
  },
  [SecurityScanResultEvidenceTypeEnum.HighChangePercentage]: {
    label: 'High Change Percentage',
    entity: 'table',
    description: 'unusually high percentage of data changes detected',
  },
};

export const getEvidenceStrings = (
  evidenceType: SecurityScanResultEvidenceTypeEnum
): { label: string; description: string; entity: string } => {
  return EvidenceTypeDisplayNameMapper[evidenceType] || evidenceType;
};
